import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Breadcrumb } from "@/components/Breadcrumb";
import { MenuDrawer } from "@/components/MenuDrawer";
import { useMenu } from "@/context/MenuContext";
import { usePlatform } from "@/hooks/usePlatform";
export function Content({ className, ...props }) {
    const location = useLocation();
    const { isOpen } = useMenu();
    const { isMobile } = usePlatform();

    useEffect(() => {}, []);

    // Вэб дээр контейнер нь ТОГТМОЛ өндөртэй (Header 40 + Footer 30-г хассан) бөгөөд
    // дотроо `overflow: hidden` тул түүнээс давсан контент таслагдана.
    //
    // Мобайлд энэ загвар тохирохгүй: агуулга нь урт (урсгалын форм + үйлдлийн
    // товчнууд) учир хайрцгаас давж, доод талын товчнууд таб самбарын доогуур
    // орж далдардаг байв. Иймд native дээр өндрийн хязгаарыг ОГТ тавихгүй —
    // агуулга байгалийн урсгалаар үргэлжилж, хуудас өөрөө гүйлгэгдэнэ.
    // Таб самбарын зайг ProtectedRoute-ийн paddingBottom хангана.
    return (
        <div className={isMobile ? "container" : "container max-h-[calc(100vh-30px-40px)] h-[calc(100vh-30px-40px)]"}>
            {isOpen && <MenuDrawer />}
            {location.pathname !== "/" && location.pathname !== "/admin" && location.pathname !== "/admin/ad" && location.pathname !== "/si" && <Breadcrumb />}
            <div
                style={{
                    // display: "flex",
                    // Мобайлд `hidden` нь урт формын доод хэсгийг таслана — харагдуулна.
                    overflow: isMobile ? "visible" : "hidden",
                    maxWidth: "100%",
                }}
                className={"" + location.pathname.search("si/si000301") !== -1 ? "no-container" : "container"}
            >
                <div style={{ flex: 1, padding: location.pathname.search("si/si000301") !== -1 ? 24 : 0, paddingTop: 0 }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
